// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__O3tg8","title":"AfterFrontImage_title__3fwHq"};